
export const useLink = () => {
    const link = localStorage.getItem("link");
    return link;
};


export const setLink = (link) => {
    if (link) {
      localStorage.setItem("link", link);
    } else {
      localStorage.setItem("link", "null");
    }
  };

